import React from "react";
import PropertyPanelWidget from "../PropertyPanelWidget";
import FolderNodeModel from "../../models/FolderNodeModel";

export default class NewFolderEmbed extends React.Component {
    /**
     * Embedded popup inside dialog for adding blank element
     * @module NewFolderEmbed
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            foldervalue: this.props.folder
        };
        this.renamechange = this.renamechange.bind(this);
        this.initTempNode();
    }

    initTempNode(){
        let basetempnode = new FolderNodeModel();
        basetempnode.name = this.props.folder;
        this.tempNode = basetempnode;
    }
    

    renamechange(e) {

        e.target.value = e.target.value.toUpperCase().replace(" ","_");
        this.setState({foldervalue:e.target.value});
    
        }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className={"col-md-12"}>
                            <label>{"Rename Folder"}</label>
                        </div>
                        <div className="col-md-12">
                            {<PropertyPanelWidget rename={this.props.folder} context={this.tempNode} embed={true}/>}
                        </div>
                    </div>
                </div>
                <div className={"element-buttons"}>
                    <button className={"w2ui-btn secondary"} onClick={() => {
                        w2popup.message()
                    }}>{window.l.popup.close}
                    </button>
                    <button className={"w2ui-btn primary"} onClick={() => {
                        if (!this.tempNode.hasError()) {
                            this.props.addFunc(this.props.id, this.tempNode.getConfig("name"));
                            w2popup.message()
                        } else {
                            alert(window.l.popup.fix_error);
                        }
                    }}>{window.l.popup.rename}
                    </button>
                </div>
            </div>
        );
    }
}